import { render } from "./FeatherUploadCloudSvg.vue?vue&type=template&id=41678884"
const script = {}
script.render = render

export default script